'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  config = require('../../config'),
  ResponsiveCarouselView = require('./../../../components/Carousel/ResponsiveCarouselView'),
  tabsTemplate = require('../../../tmpl/client/carousel/tabbedCarouselTabs.hbs'),

  TabbedCarouselView = Backbone.View.extend({
    events: {
      'click .BlackHeader--keyline-button': 'onTabClick'
    },

    initialize: function() {
      this.$tabContents = this.$el.find('.TabbedCarousel-content');
      this.$headers = this.$el.find('.BlackHeader');
      this.$carousels = this.$el.find('.TabbedResponsiveCarousel');

      this.initializeTabs();
      this.initializeCarousels();
    },

    initializeTabs: function() {
      var tabs = this.$headers.map(function() { return $(this).text(); }).get();
      this.$el.prepend(tabsTemplate({ tabs: tabs }));
      this.$tabs = this.$el.find('.BlackHeader--keyline-button');
      this.$seeAll = this.$el.find('.BlackHeader--keyline-cta');
      this.updateLink(0);
    },

    initializeCarousels: function() {
      // Create the carousel views
      this.$carousels.each(function(n, el) {
        new ResponsiveCarouselView({
          el: el,
          slickMaxBreakpoint: 1023,
          arrows: false
        });
      });
    },

    onTabClick: function(e) {
      e.preventDefault();
      var index = this.$tabs.index(e.currentTarget);
      this.showTab(index);
    },

    showTab: function(index) {
      this.$tabContents.removeClass(config.classes.isActive);
      this.$tabContents.eq(index).addClass(config.classes.isActive);

      this.$tabs.removeClass(config.classes.isActive);
      this.$tabs.eq(index).addClass(config.classes.isActive);

      this.updateLink(index);
    },

    updateLink: function(index) {
      var $link = this.$headers.eq(index).find('a');

      if ($link.length) {
        this.$seeAll.removeClass(config.classes.uHide);
        this.$seeAll.attr('href', $link.attr('href'));
      } else {
        this.$seeAll.addClass(config.classes.uHide);
      }
    }
  }, {
    create: function($parent) {
      $parent.find('.TabbedCarousel').each(function(n, el) {
        new TabbedCarouselView({
          el: el
        });
      });
    }
  });

module.exports = TabbedCarouselView;



// WEBPACK FOOTER //
// ./assets/js/components/carousel/TabbedCarouselView.js